import type { NavItem as DsNavItem } from '@edgeconnex/design-system'

export type AppNavItem = Omit<DsNavItem, 'children'> & {
  group?: 'top' | 'main' | 'bottom'
  /** An array means any-of: the item shows when the user holds at least one. */
  requiredPrivilege?: string | string[]
  children?: AppNavItem[]
}

// Children are privilege-filtered independently of their branch; a branch whose children all
// filter away is hidden entirely (it has no destination of its own).
export function filterNavItems(
  items: AppNavItem[],
  can: (privilege: string) => boolean,
): AppNavItem[] {
  return items.flatMap((item) => {
    if (item.requiredPrivilege) {
      const required = Array.isArray(item.requiredPrivilege)
        ? item.requiredPrivilege
        : [item.requiredPrivilege]
      if (!required.some((privilege) => can(privilege))) return []
    }
    if (!item.children) return [item]
    const children = filterNavItems(item.children, can)
    return children.length ? [{ ...item, children }] : []
  })
}
